import { apiGet, apiPost, apiPut } from '.';
import {
  BareImage,
  FSImage,
  Image,
  ImageUsage,
  NewImage,
  PaginateImageParams,
} from '@go-shared/types/image';
import { PaginationResult } from '@go-shared/types/pagination';
import qs from 'query-string';

export async function getImages(): Promise<BareImage[]> {
  let images = (await apiGet('/image')) as any;
  return images;
}

export async function getDiskImages(): Promise<FSImage[]> {
  let images = (await apiGet('/disk-image')) as any;
  return images;
}

export async function paginateImages(
  params: PaginateImageParams
): Promise<PaginationResult<Image>> {
  const { ...rest } = params;

  return apiGet(`/image/paginate?${qs.stringify(rest)}`);
}

export async function cherrypickImages(keys: string[]): Promise<BareImage[]> {
  if (keys.length === 0) {
    return [];
  }
  const images = (await apiPost(`/image/cherrypick`, { keys })) as any;
  return images;
}

export async function deleteImage(path: string): Promise<boolean> {
  let success = (await apiPost(`/image-delete`, { path })) as any;
  return success;
}

export async function createImage(image: NewImage): Promise<BareImage> {
  return apiPost(`/image`, image);
}

export async function updateImage(image: BareImage): Promise<BareImage> {
  return apiPut(`/image/${image._id}`, image);
}

export async function getImageUsage(image: Image): Promise<ImageUsage> {
  return apiGet(`/image/${image._id}/usage`) as Promise<ImageUsage>;
}
